import React, { useState } from "react";
import tab3 from "../../../Assets/Images/tab3.png";
import menu_open from "../../../Assets/Images/menu_open.png";
import { Menu, Drawer, Spin } from "antd";
import logo from "../../../Assets/Images/logo.png";
const MobileMenu = ({ items = [] }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="mobile_menu">
        <div onClick={showDrawer} className="menu_icon">
          <img src={open ? menu_open : tab3} alt="" />
        </div>
        <Drawer
          title={<img src={logo} alt="" style={{height: "40px"}} />}
          placement="right"
          onClose={onClose}
          open={open}
          style={{ padding: 0 }}
          width={260}
        >
          {loading === true ? (
            <div className="spin_center">
              <Spin />
            </div>
          ) : (
            <Menu
              theme="light"
              defaultSelectedKeys={["1"]}
              mode="inline"
              items={items}
              onClick={onClose}
            />
          )}
        </Drawer>
      </div>
    </>
  );
};

export default MobileMenu;
